import { EventContextResponse } from "../types/tracking";
import { TRACK_LABEL } from "../types/constants";
import { SEARCH_BOX_ACTION } from "../types/sqrl/constants";
import { TrackingEvent } from "../events";

export class NavSlider {
  private _template: HTMLDivElement | null = null;
  private updated: boolean = false;

  private saveHTMLTemplate(): HTMLDivElement {
    const navSliderContainer = document.querySelector(".js_squirrel_navSliderContainer") as HTMLDivElement;
    navSliderContainer.removeAttribute("style");
    const template: HTMLDivElement = navSliderContainer;
    navSliderContainer.outerHTML = "";
    return template;
  }

  public updateHTMLTemplateOnce(): void {
    if (!this.updated) {
      this._template = document.querySelector(".js_squirrel_navSliderContainer") as HTMLDivElement;
      this.updated = true;
    }
  }

  get template(): HTMLDivElement {
    if (!this._template) {
      this._template = this.saveHTMLTemplate();
    }
    return this._template;
  }

  onMergeEventContext(response: EventContextResponse) {
    const trackingData = { [TRACK_LABEL.SEARCH_BOX_ACTION]: SEARCH_BOX_ACTION.CLICK };
    TrackingEvent.addToMergeId(trackingData, response.eventMergeId);
  }
}

export const navSlider = new NavSlider();
